/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
import jwtDecode from "jwt-decode";

import { IJwtTokenData } from "../interfaces/IJwtTokenData";
import { TokenStatus } from "../types/token";

const STORAGE_PREFIX = "ALESA.FE";
const AUTH_TOKEN_KEY = `${STORAGE_PREFIX}.AUTH_TOKEN`;
const LAST_PAGE_KEY = `${STORAGE_PREFIX}.LAST_PAGE`;

export function getAzureADTokenPayload(token: string) {
  return jwtDecode(token);
}

export function setAuthToken(token: string): void {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function getAuthToken(): TokenStatus | null {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) {
    return null;
  }

  try {
    const decodedToken: IJwtTokenData = jwtDecode(token);
    const now = Math.floor(Date.now() / 1000);
    const isExpired = now >= decodedToken.exp;
    const isBypass = !!(
      decodedToken.BypassActorBinusianId &&
      decodedToken.BypassActorBinusianId.trim() !== ""
    );
    return { value: token, isExpired, isBypass };
  } catch {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    return null;
  }
}

export function removeAuthToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function setLastVisitedPage(url: string): void {
  const pathToStore = url === "/bypass" ? "/" : url;
  sessionStorage.setItem(LAST_PAGE_KEY, pathToStore);
}

export function getLastVisitedPage(): string {
  const lastPage = sessionStorage.getItem(LAST_PAGE_KEY) || "/";
  return lastPage === "/bypass" ? "/" : lastPage;
}

export function removeLastVisitedPage(): void {
  sessionStorage.removeItem(LAST_PAGE_KEY);
}

export function cleanupStorage(): void {
  const lastVisitedPage = getLastVisitedPage();

  localStorage.clear();
  sessionStorage.clear();

  if (lastVisitedPage) {
    setLastVisitedPage(lastVisitedPage);
  }
}
